var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"app-container__header"}},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.activeMenus),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(item.meta.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }